import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, MessageSquareText } from 'lucide-react';
import { Textarea } from '../../ui/textarea';
import { Card, PrimaryButton } from '../ui';
import { adminApi } from '../../../pages/journey/journeyApi';

const when = (iso) => new Date(iso).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' });

export const KickoffNotes = ({ student, onSaved }) => {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const notes = [...(student.kickoff_notes || [])].reverse();
  const add = async () => {
    setBusy(true);
    try {
      await adminApi(`/students/${student.id}/notes`, { method: 'POST', body: { text } });
      setText(''); toast.success('Note added'); onSaved();
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <Card data-testid="admin-kickoff-notes">
      <div className="flex items-center gap-2 mb-1"><MessageSquareText className="w-4 h-4 text-teal-600" /><p className="font-outfit font-semibold text-[#0b1f4d]">Kickoff call notes</p></div>
      <p className="text-xs text-slate-500 mb-3">Shared with the whole team. Each note keeps your name and time.</p>
      <Textarea rows={3} value={text} onChange={(e) => setText(e.target.value)} placeholder="What did you learn on the call? Goals, concerns, agreed next steps…" data-testid="kickoff-note-input" />
      <PrimaryButton onClick={add} disabled={busy || !text.trim()} className="mt-2 w-full" data-testid="kickoff-note-add-btn">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Add note'}
      </PrimaryButton>
      <ol className="mt-5 space-y-3 max-h-[420px] overflow-y-auto pr-1" data-testid="kickoff-notes-list">
        {!notes.length && <li className="text-sm text-slate-500" data-testid="kickoff-notes-empty">No notes yet.</li>}
        {notes.map((n) => (
          <li key={n.id} className="rounded-xl bg-slate-50 border border-slate-100 p-3" data-testid={`kickoff-note-${n.id}`}>
            <p className="text-xs text-slate-500"><span className="font-semibold text-[#0b1f4d]">{n.author}</span> · {when(n.at)}</p>
            <p className="text-sm text-slate-700 mt-1 whitespace-pre-line">{n.text}</p>
          </li>
        ))}
      </ol>
    </Card>
  );
};
